import { EmptyState, FlexColumn, FlexRow, Loading, MaterialIcon } from '@gorila-shared-ui/components';
import { Button } from 'baseui/button';
import { LabelMedium } from 'baseui/typography';
import { useState } from 'react';
import { useRecoilState } from 'recoil';
import useEffectOnce from '../../hooks/useEffectOnce';
import { useFeedback } from '../../hooks/useFeedback';
import { useStyles } from '../../hooks/useStyles';
import { liveStatusState } from '../../storage/liveStatus';
import { StyledTooltip } from '../ui/StyledTooltip';
import LiveStatusCard from './LiveStatusCard';
import { useLiveStatus } from './hooks/useLiveStatus';

export function LiveStatusList() {
  const { css, theme } = useStyles();
  const [loading, setLoading] = useState(false);
  const [liveStatus, setLiveStatus] = useRecoilState(liveStatusState);
  const { showFailFeedback } = useFeedback();
  const { getLiveStatusList } = useLiveStatus();

  const loadLiveStatus = async () => {
    setLoading(true);
    const response = await getLiveStatusList();
    if (response?.error) {
      showFailFeedback(response.error || 'Ocurrió un error al cargar el estado en vivo, inténtalo más tarde.');
      setLiveStatus(undefined);
    } else if (response?.liveStatus) {
      setLiveStatus(response.liveStatus);
    }
    setLoading(false);
  };

  useEffectOnce(() => {
    loadLiveStatus();
  });

  return (
    <FlexColumn
      gap={0}
      classNames={css({ height: '100%' })}
    >
      <FlexRow
        classNames={`${css({
          backgroundColor: theme.colors.backgroundInversePrimary,
          padding: theme.sizing.scale500,
          color: theme.colors.white,
          alignItems: 'center',
          justifyContent: 'space-between',
          minHeight: '60px',
          boxSizing: 'border-box',
        })}`}
      >
        <LabelMedium color={theme.colors.contentInversePrimary}>Prevención de riesgos</LabelMedium>
        <StyledTooltip
          content={'Actualizar información'}
          showArrow={false}
        >
          <Button
            size="compact"
            shape="square"
            onClick={loadLiveStatus}
            kind="primary"
          >
            <MaterialIcon
              name="refresh"
              color={theme.colors.contentInversePrimary}
            />
          </Button>
        </StyledTooltip>
      </FlexRow>
      <FlexColumn classNames={css({ padding: theme.sizing.scale600, flex: '1', overflow: 'hidden' })}>
        {loading && <Loading />}
        {!liveStatus && !loading && <EmptyState title="No se puede mostrar el estado en vivo." />}
        {liveStatus && !loading && (
          <FlexColumn classNames={css({ overflowY: 'auto' })}>
            {!!liveStatus.length &&
              liveStatus.map((status, index) => (
                <div key={index}>
                  <LiveStatusCard
                    title={status.label}
                    quantity={status.total}
                    percentage={status.percentage}
                    universe={status.universe}
                    identifier={status.identifier}
                  />
                </div>
              ))}
          </FlexColumn>
        )}
      </FlexColumn>
    </FlexColumn>
  );
}
